export const SOCIAL_MEDIA_LINKS = {
  github: 'https://github.com/deontsanchez',
  linkedin: 'https://www.linkedin.com/in/deon-sanchez-45815a94/',
  facebook: 'https://www.facebook.com/deon.sanchez',
  instagram: 'https://www.instagram.com/deon_sanchez/',
  tiktok: 'https://www.tiktok.com/@chickenhd13',
  email: 'mailto:deontsanchez@gmail.com',
  x: 'https://x.com/Sanchez_Node',
};
